Wee.fn.make('curriculumPage', {
    init: function() {
        var $downloadBtn = $('.js-submit'),
            $downloadModal = $('.js-download-modal'),
            $form = $('ref:preschoolForm'),
            $emailInput = $('.js-email-input'),
            $checkbox = $('.js-sign-up'),
            $error = $('.js-input-err'),
            $videoModal = $('.js-video-modal'),
            priv = this.$private;

        $.events.on({

            // Toggle Accordion Panels
            'ref:accordion-btn': {
                click: function(e, el) {
                    var $panel = Wee.$siblings(el, '.js-accordion-panel')[0];
                    Wee.$toggleClass(el, '-active');
                    Wee.$toggleClass($panel, '-open');

                    if ($panel.style.maxHeight) {
                        $panel.style.maxHeight = null;
                    } else {
                    $panel.style.maxHeight = $panel.scrollHeight + 'px';
                    }
                }
            },
            'ref:download-modal-open': {
                click: function(e) {
					e.preventDefault();
					priv.showDownload();
                }
            },
            'ref:download-modal-close': {
                click: function() {
                    priv.hideDownload();
                }
			},
			'ref:video-play': {
                click: function(e) {
                    e.preventDefault();
					priv.playVideo();
                }
            },
            'ref:video-close': {
                click: function() {
                    priv.hideVideo();
                }
            },
            'window': {
                click: function(e) {
                    if (e.target === $downloadModal[0]) {
						priv.hideDownload();
					} else if (e.target === $videoModal[0]) {
						priv.hideVideo();
					}
                },
                keydown: function(e) {
                    if (e.keyCode === 27) {
						priv.hideDownload();
						priv.hideVideo();
                    }
                }
            },
            '.js-email-input': {
                input: function(e, el) {
                    if (el.value !== '') {
						priv.hideErrors();
                    }
                }
            },
            '.js-sign-up': {
                click: function(e, el) {
                    if (el.checked == true) {
						priv.hideErrors();
                    }
                }
            },
        });

        $form.on('submit', function(e, el) {
            var $el = $(el),
                $email = $emailInput[0].value,
                $isChecked = $checkbox[0].checked,
                validation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                emailIsValid = validation.test($email);

            // Validation
            if ($email === '' || $isChecked === false || !emailIsValid) {
                e.preventDefault();
                $downloadBtn[0].disabled = true;
                $error.css('display', 'block');
                return false;
            }

            // Submit form via ajax
            Wee.fetch.request({
                url: window.location.href,
                method: 'post',
                data: $el.serialize(),
                success: function(response) {
                    var success = response.success,
                        errors = response.errors;

                    // Reset error messages
                    $('ref:errorMessage').text('');

                    var a = document.createElement('a');
					a.href = $.get('preschoolDownloadLink');
                    a.download = $.get('preschoolDownloadName');
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    // Notify user of submission state
                    if (! success && errors && Object.keys(errors).length) {
                        for (var error in errors) {
                            priv.insertErrors(error, errors[error]);
                        }
                    } else {
                        $el.prepend($.view.render('preschool-success', {
                            text: $.get('preschoolText')
                        }));
                        $el.find('ref:close').hide();
                        $('ref:close').hide();
                    }
                },
                error: function(response) {
                    console.log(response);
                }
            });
            e.preventDefault();
        });
    }
}, {
	showDownload: function() {
		$('.js-download-modal').css('display', 'block');
	},
    hideDownload: function() {
		$('.js-download-modal').css('display', 'none');
	},
	hideVideo: function() {
		$('.js-video-modal').css('display', 'none');
		$('.js-modal-video')[0].pause();
		$('.js-hero-video')[0].play();
	},
	playVideo: function() {
		$('.js-hero-video')[0].pause();
		$('.js-video-modal').css('display', 'flex');
		$('.js-modal-video')[0].autoplay = true;
		$('.js-modal-video')[0].load();
	},
	insertErrors: function(type, errors) {
        console.log(type, errors[0]);
        $('ref:' + type + 'Error').text(errors[0]);
	},
	hideErrors: function() {
		$('.js-input-err').css('display', 'none');
		$('.js-submit')[0].disabled = false;
	}
});

Wee.curriculumPage.init();
